import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cartRadio", "cartSpoSelect", "sharedSpoSelect"]

  mirrorPaymentType(event) {
    const value = event.target.value
    this.cartRadioTargets
      .filter(r => r.value === value)
      .forEach(radio => {
        radio.checked = true
        radio.dispatchEvent(new Event('change', { bubbles: true }))
      })
    if (value === 'standing_purchase_order') {
      this.mirrorSpoSelect()
    }
  }

  mirrorSpoSelect() {
    const value = this.sharedSpoSelectTarget.value
    this.cartSpoSelectTargets.forEach(select => { select.value = value })
  }
}
